"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Loader = void 0;
var _react = _interopRequireDefault(require("react"));
var _Spinner = _interopRequireDefault(require("react-bootstrap/Spinner"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const Loader = _ref => {
  let {
    type = "textOnly",
    style = {}
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("div", {
    style: {
      ...style,
      display: "flex",
      justifyContent: "center",
      alignItems: "center"
    }
  }, type === "textOnly" ? /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
    className: "custom-loader"
  }, "Loading...")) : /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_Spinner.default, {
    animation: "border",
    role: "status"
  })));
};
exports.Loader = Loader;